import { render, staticRenderFns } from "./bought.vue?vue&type=template&id=1761874e&scoped=true&"
import script from "./bought.vue?vue&type=script&lang=js&"
export * from "./bought.vue?vue&type=script&lang=js&"
import style0 from "./bought.vue?vue&type=style&index=0&id=1761874e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1761874e",
  null
  
)

export default component.exports